'use client'
import { Utils } from '@/lib/utils';
import { useEffect } from 'react';

interface WidgetDemoProps {
      subdomain: string;
      widgetId: string;
}

const WidgetDemo = ({ subdomain, widgetId }: WidgetDemoProps) => {
      useEffect(() => {
            // Adiciona o script diretamente ao HTML
            const script = document.createElement('script');
            script.innerHTML = Utils.widget.generateScript(subdomain, widgetId);
            document.head.appendChild(script);

            return () => {
                  if (window.kw) {
                        window.kw('close');
                  }
            };
      }, []);

      return (
            <div id="widget-demo" className="container mx-auto py-10 px-4">

            </div>
      );
}

export default WidgetDemo;
